<template>
    <div wire:ignore>
    	<component :is="component" v-if="component" />
    </div>
</template>

<script>
export default {
    props: {
        src: {
            type: String,
            required: true
        },
        channel: {
            type: String,
            required: false
        },
        listen: {
            type: String,
            required: false
        }
    },

    data() {
        return {
            component: null
        }
    },

    methods: {
        reload() {
            axios.post(this.src, [])
                .then(response => {
                    this.component = Vue.compile(response.data);
                });
        },

        registerReloadListener() {
            if (! this.channel || ! this.listen) {
                return false;
            }

            window.Echo.channel(this.channel)
                .listen(this.listen, (e) => {
                    this.reload();
                });
        }
    },

    mounted() {
        this.reload();
        this.registerReloadListener();
    }
}
</script>
